import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import MenuList from './components/MenuList'
import FilteredResults from './components/FilteredResults'
import App from './App.vue'
import VueScrollTo from 'vue-scrollto'
import mp from 'mixpanel-browser'
import { MIXPANEL_DEV_API_KEY } from '../localTestKeys'

// TODO: Create a separate file for Mixpanel stuff
var productionHost = 'www.highlandstar.co.uk';
var devToken = MIXPANEL_DEV_API_KEY;
var prodToken = process.env.VUE_APP_MIXPANEL_PROD_API_KEY;

//If the hostname is anything other than your production domain, initialize the Mixpanel library with your Development Token 
if (window.location.hostname.toLowerCase().search(productionHost) < 0) {
  mp.init(devToken);
} else { mp.init(prodToken); }

export const mixpanel = mp

Vue.use(VueRouter)

// This is declared here so the rest of the application can use the 'v-scroll-to' directive (See Menu button)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 1200,
  easing: "ease",
  offset: -62,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

export const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    component: MenuList
  },
  {
    path: '/filter',
    component: FilteredResults
  }]
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
